export const EInvoiceStatus = {
  "0": "UNKNOWN",
  "1": "NEW",
  "2": "CANCELED",
  "3": "TRANSFERED",
  "5": "COLLECTED",
  "-1": "ALL"
};

export const EInvoiceType = {
  "0": "UNKNOWN",
  "1": "AGENCY_CARI",
  "2": "AGENCY_CREDITCARD",
  "3": "AGENCY_CREDITCARD_COMMISSION",
  "4": "GSA_CARI",
  "5": "GSA_CREDITCARD",
  "6": "GSA_CREDITCARD_COMMISSION",
  "-1": "ALL"
};

export const EInvoiceHeaderType = {
  "0": "UNKNOWN",
  "1": "PRODUCT",
  "2": "SERVICE_FEE",
  "-1": "ALL"
};

export const EInvoiceIO = {
  "0": "UNKNOWN",
  "1": "INCOMING",
  "2": "OUTGOING",
  "-1": "ALL"
};

export const EInvoiceTrxViewType = {
  "0": "UNKNOWN",
  "1": "ACCOWNER",
  "2": "ACCOWNER_DATE",
  "3": "ACCOWNER_DATE_ORDER",
  "4": "ACCOWNER_DATE_ORDER_ENTITY",
  "5": "ACCOWNER_DATE_ORDER_ENTITY_SUBENTITY",
  "-1": "ALL"
};

export const EInvoicePackageType = {
  "0": "UNKNOWN",
  "1": "ACCOWNER",
  "2": "ACCOWNER_DATE",
  "3": "ACCOWNER_DATE_ORDER",
  "4": "ACCOWNER_VALOR",
  "-1": "ALL"
};

export const EInvoiceDateType = {
  "0": "UNKNOWN",
  "1": "SALES_DATE",
  "2": "CHECKIN_DATE",
  "3": "CHECKOUT_DATE",
  "-1": "ALL"
};

export const EInvoicePeriodType = {
  "0": "UNKNOWN",
  "1": "WEEKLY",
  "2": "BIWEEKLY",
  "3": "MONTHLY",
  "-1": "ALL"
};